import React, { useMemo } from "react";
import { formatDateRange, calculatePercentageChange, previousYearPeriod, generatePeriodNames, percentageChange, validateNestedData, toggleHttps, parseEditedHTML } from "../../../exportreport/utils";
import {
  _capitalizeText,
  _formatNumber,
  _formatPrice,
  _formatCurrency,
  _nameToUrl,
  _shouldShow,
  _getBuildingURL,
  buildingFL,
  _replaceAbbreviations,
  _formatBed,
  propertyFL,
  SalesProgress,
  _isEqual,
  _tranformTagsQuery,
  syncURLFilters,
  syncURLSearch,
  setURLFromState,
  setLocalStorage,
  getLocalStorage,
  deleteLocalStorage,
  syncStageFilters,
  mpndCohortQuery,
  syncGenericFilter,
  urlSlugBuilding,
  _isNewUser,
  _isEnterpriseUser,
  _objectEqual,
  getCohortQuery,
  _activityFQ,
  _isHouse,
  _formatBigPrice,
  houseBuildingCohortQuery,
  _activityFL,
} from "../../../../../../shared/helpers/utils";
import ImageCoverPage from "./ImageCoverPage";

const CoverPage = function(props){
  const {
    name,
    title,
    type,
    reportData,
    reportItem,
    searchTags,
    summarizeGeographies,
    priorYearPeriodName,
    currentPeriodName,
    customDate,
    color,
    AiResponse,
    formValues,
    defaultLogo,
    user,
    dateDisplay,
    editedContent = ""
  } = props;

  // Build edited content map once per editedContent change
  const editedMap = useMemo(function(){ return parseEditedHTML(editedContent); }, [editedContent]);

  // Namespace helper to keep IDs unique across subcomponents/pages
  var ns = function(localId){
    var key = type && type.key ? String(type.key) : "cover";
    return key + "-" + localId;
  };

  // Render edited HTML if present and marked as changed, otherwise render fallback JSX
  function renderEditedOrDefault(id, fallback) {
    if (!editedMap || !editedMap[id]) return fallback;

    try {
      var parser = new DOMParser();
      var doc = parser.parseFromString(editedMap[id], "text/html");
      var el = doc.body.firstElementChild;

      if (el && el.getAttribute("data-changed") === "true") {
        return <div dangerouslySetInnerHTML={{ __html: el.outerHTML }} />;
      }
    } catch (e) {
      console.warn("Failed to parse edited HTML for id:", id, e);
    }

    return fallback;
  }

  if (!formValues) return null;
  if (formValues && formValues.cover && formValues.cover == "hide") return null;
  if (formValues && formValues.cover && formValues.cover == "image") return <ImageCoverPage {...props} />;

  return (
    <div className="report-container page-section cover-page no-header">
      <section className="report-section">

        {renderEditedOrDefault(
          ns("coverTitle"),
          <h1 className="cover-title editable track-original" id={ns("coverTitle")}>
            {searchTags && searchTags.length > 0 ? _capitalizeText(summarizeGeographies(searchTags)) : "New York City"}
          </h1>
        )}

        {renderEditedOrDefault(
          ns("coverSubtitle"),
          <h2 className="cover-sub-title editable track-original" id={ns("coverSubtitle")}>
            {title || reportItem.name}
          </h2>
        )}

        <hr/>
        <div>
          {dateDisplay
            ? renderEditedOrDefault(
                ns("coverDate"),
                <div className="cover-date editable track-original" id={ns("coverDate")}>{dateDisplay}</div>
              )
            : renderEditedOrDefault(
                ns("coverDate"),
                <div className="cover-date editable track-original" id={ns("coverDate")}>{priorYearPeriodName} vs. {currentPeriodName}</div>
              )
          }
        </div>

        <div className="image-cover-logo">
          <div>
            {user && user.corpLogo ? (
              <img className="" src={user.corpLogo} />
            ) : null}
          </div>
          <div>
            {formValues &&
            formValues.branding &&
            (formValues.branding === "mylogo" || (!user || !user.corpLogo && formValues.branding === "marketproof")) &&
            user &&
            user.logo ? (
              <img className="" src={user.logo} />
            ) : null}
          </div>
        </div>
      </section>
    </div>
  );
};

export default CoverPage;
